/** Point vert pulsant « quelqu'un est là maintenant ». */
export const LiveVisitorDot = ({ taille = "md" }) => {
  const tailles = { sm: "h-1.5 w-1.5", md: "h-2 w-2", lg: "h-3 w-3" };
  return (
    <span className={`relative flex ${tailles[taille] || tailles.md}`} data-testid="live-visitor-dot">
      <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping" />
      <span className="relative inline-flex h-full w-full rounded-full bg-emerald-500" />
    </span>
  );
};

export default LiveVisitorDot;
